"use client";
import dynamic from "next/dynamic";

const Inner = dynamic(() => import("./Inner").then((mod) => mod.Inner), { ssr: false });

export const Trustpilot = () => (
  <div className="hidden xl:block absolute bottom-3 right-3">
    <Inner />
  </div>
);
